import { ROLES_KEYS } from 'Config/constants'
import find from 'lodash/find'

export const isUserRole = (user, role) => {
  const el = find(user?.roles, elem => elem === role)
  return el
}

export const isUserRoleStef = user => isUserRole(user, ROLES_KEYS.ROLE_STEF)

export const isUserRoleApprover = user => isUserRole(user, ROLES_KEYS.ROLE_APPROVER)

export const isUserLogirest = user => {
  const iU = isUserRole(user, ROLES_KEYS.ROLE_LOGIREST)
  return iU
}
export const isUserSupply = user => {
  const iU = isUserRole(user, ROLES_KEYS.ROLE_SUPPLY)
  return iU
}
